/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ComIbmCommerceMarketingFacadeDatatypesAreaTypeUserData } from './com-ibm-commerce-marketing-facade-datatypes-area-type-user-data';

/**
 * 
 * @export
 * @interface ComIbmCommerceMarketingFacadeDatatypesAreaType
 */
export interface ComIbmCommerceMarketingFacadeDatatypesAreaType {
    /**
     * 
     * @type {ComIbmCommerceMarketingFacadeDatatypesAreaTypeUserData}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    userData?: ComIbmCommerceMarketingFacadeDatatypesAreaTypeUserData;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    target?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    url?: string;
    /**
     * 
     * @type {number}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    displaySequence?: number;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    coordinates?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    shape?: ComIbmCommerceMarketingFacadeDatatypesAreaTypeShapeEnum;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    uniqueID?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    alternateText?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ComIbmCommerceMarketingFacadeDatatypesAreaTypeShapeEnum {
    Rect = 'rect',
    Circle = 'circle',
    Poly = 'poly'
}



